import { useLingui } from '@lingui/react/macro';

import { MobileEntityFilter } from '@/components/SharedFilters/EntityFilter/MobileEntityFilter';
import IconAssociate from '@/icons/Associate.svg';

import { useFilters } from '../FiltersState';

export const MobileFiltersEntityOrGroup = () => {
  const { t } = useLingui();

  const {
    entityOrGroupSelections: { entityOrGroupSelections, setEntityOrGroupSelections },
  } = useFilters();

  return (
    <MobileEntityFilter
      filterId="entity-or-group"
      selectedEntities={entityOrGroupSelections}
      setSelectedEntities={setEntityOrGroupSelections}
      label={t({
        id: 'settings.organization.entities.agreements.filters.entity.label',
        message: 'Entity',
      })}
      searchPlaceholder={t({
        id: 'settings.organization.entities.agreements.filters.entity.search',
        message: 'Search entities and groups',
      })}
      icon={<IconAssociate />}
    />
  );
};
